<template>
  <div id="time-indicator">
    <span>{{ $_hours }}</span>
    <span>{{ $_minutes }}</span>
    <span>{{ $_seconds }}</span>
  </div>
</template>

<style scoped>
#time-indicator {
  font-size: 11px;
}

#time-indicator > span:not(:last-child):after {
  content: ':';
  padding: 0 2px;
}
</style>

<script>
import TimeValue from '../../modules/TimeValue.js';

export default {
  props: {
    time: { type: TimeValue, default: TimeValue.zero },
  },

  computed: {
    $_timeComponents() {
      return this.time.getTimeComponentsAsString();
    },

    $_hours() {
      return this.$_timeComponents.hour;
    },

    $_minutes() {
      return this.$_timeComponents.min;
    },

    $_seconds() {
      return this.$_timeComponents.sec;
    },
  },
}
</script>